// extracted by mini-css-extract-plugin
module.exports = {"header":"ErrorBoundary_header___ZN2_","backLink":"ErrorBoundary_backLink__-IcGo"};